import DeleteDeviceModal from './DeleteDeviceModal';

export default DeleteDeviceModal;
